import CommonService from "@/services/CommonService";
// import swal from 'sweetalert'
export default {
  created: function() {
    CommonService.getSiteMode().then(result => {
      if (result.data.ln_key == "true") {
        this.$store.dispatch("logout");
        this.$store.dispatch("setSiteMode", true);
      } else {
        this.$store.dispatch("setSiteMode", false);
      }
    });
  }
};
